import { useMutation } from '@tanstack/react-query';
import { authService } from 'shared/src/api';

export const usePostAppleLogin = () => {
  return useMutation({
    mutationFn: authService.postAppleLogin,
    throwOnError: false,
  });
};
